const CLONALITY_CADENCE_MS = 6 * 60 * 60 * 1000;

function parseTimestamp(value) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}

function formatDuration(milliseconds) {
  const absMilliseconds = Math.abs(milliseconds);
  const minutes = Math.max(1, Math.round(absMilliseconds / 60000));

  if (minutes < 60) {
    return `${minutes}m`;
  }

  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `${hours}h`;
  }

  return `${Math.round(hours / 24)}d`;
}

export function formatPastRelativeTime(value, now = new Date()) {
  const date = parseTimestamp(value);
  const nowDate = parseTimestamp(now);
  if (!date || !nowDate) {
    return 'Unavailable';
  }

  const diff = date.getTime() - nowDate.getTime();
  if (diff > 0) {
    return `in ${formatDuration(diff)}`;
  }

  return `${formatDuration(diff)} ago`;
}

export function formatFutureRelativeTime(value, now = new Date()) {
  const date = parseTimestamp(value);
  const nowDate = parseTimestamp(now);
  if (!date || !nowDate) {
    return 'Unavailable';
  }

  const diff = date.getTime() - nowDate.getTime();
  if (diff <= 0) {
    return 'due now';
  }

  return `in ${formatDuration(diff)}`;
}

export function getLatestCompletedClonalityExecution(executions = []) {
  return (executions || [])
    .filter((execution) => (
      execution?.attributes?.status === 'succeeded'
      && parseTimestamp(execution.attributes.completed_at)
    ))
    .sort((left, right) => (
      new Date(right.attributes.completed_at).getTime() - new Date(left.attributes.completed_at).getTime()
    ))[0] || null;
}

export function formatSampleCount(count) {
  if (typeof count !== 'number' || !Number.isFinite(count)) {
    return 'Unavailable';
  }

  return `${count.toLocaleString()} sample${count === 1 ? '' : 's'}`;
}

export function getClonalityStatusSummary({ executions, awaitingSampleCount, now = new Date() } = {}) {
  const latestCompletedExecution = getLatestCompletedClonalityExecution(executions);
  const lastRunAt = parseTimestamp(latestCompletedExecution?.attributes?.completed_at);
  const nextRunAt = lastRunAt ? new Date(lastRunAt.getTime() + CLONALITY_CADENCE_MS) : null;

  return {
    lastRunLabel: formatPastRelativeTime(lastRunAt, now),
    nextRunLabel: formatFutureRelativeTime(nextRunAt, now),
    awaitingSampleCountLabel: formatSampleCount(awaitingSampleCount),
  };
}
